import API from 'js/lib/api';

export default API('/api/authoringCourseBranchModerationData.v1/', {
  type: 'rest',
});
